import React from 'react';
import PropTypes from 'prop-types';

import Icon from 'dpl/common/components/Icon';
import Drawer, {
  DrawerItem,
  DrawerItemTitle,
  DrawerItemContent
} from 'dpl/common/components/Drawer';
import FullPageQuizQuestion from 'dpl/components/FullPageQuiz/FullPageQuizQuestion';
import {
  HELP_CENTER_ON_PLATFORM_PAYMENT_POLICY_PATH,
  STANDARDS_PATH,
  PAYMENT_PROTECTION_POLICY_PATH
} from 'dpl/shared/constants/urls';
import { isLessThanBreakpoint } from 'dpl/util/grid';

const IS_LT_MD = isLessThanBreakpoint('md');
const ICON_DIMENSIONS = IS_LT_MD ? '24px' : '32px';

function PayPrefenceQuestionDrawer({ icon, title, children }) {
  return (
    <DrawerItem itemKey={title} className="bb b--moon-gray">
      <DrawerItemTitle arrowClassName="black">
        <div className="align-items-center fw-medium f3 f4-md flex tl">
          <Icon
            className="mr5"
            height={ICON_DIMENSIONS}
            name={icon}
            width={ICON_DIMENSIONS}
          />
          <p>{title}</p>
        </div>
      </DrawerItemTitle>
      <DrawerItemContent>
        <div className="tl ph11 ph13-md">{children}</div>
      </DrawerItemContent>
    </DrawerItem>
  );
}

PayPrefenceQuestionDrawer.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};

export default function QuizGoodDogPayPreferenceQuestion({
  handleNextClick,
  onSubmit
}) {
  return (
    <div className="AdoptionApplicationQuizGoodDogPayPreferenceQuestion">
      <FullPageQuizQuestion
        handleNextClick={handleNextClick}
        onSubmit={onSubmit}
        title="To protect our community, always pay on Good Dog"
        className="ph15-md"
        isValid
      >
        <Drawer>
          <PayPrefenceQuestionDrawer
            icon="secure"
            title="Protects your payment"
          >
            <p>
              When you pay on Good Dog with Protection &amp; Support,
              you&apos;re backed by the{' '}
              <a
                href={PAYMENT_PROTECTION_POLICY_PATH}
                className="underline"
                target="_blank"
                rel="noopener noreferrer"
              >
                Good Dog Guarantee
              </a>
              .
            </p>
          </PayPrefenceQuestionDrawer>
          <PayPrefenceQuestionDrawer
            icon="ideograph-heart"
            title="Supports your breeder"
          >
            <p className="mb4">
              100% of your puppy payments go directly to your breeder. Our{' '}
              <a
                href={HELP_CENTER_ON_PLATFORM_PAYMENT_POLICY_PATH}
                className="underline"
                target="_blank"
                rel="noopener noreferrer"
              >
                On-Platform Payment Policy
              </a>{' '}
              requires that you complete all dog payments to Good Dog breeders
              on our platform.
            </p>
          </PayPrefenceQuestionDrawer>
          <PayPrefenceQuestionDrawer
            icon="dog"
            title="Creates a better world for dogs"
          >
            <p>
              When you pay on Good Dog, you&apos;re furthering our mission to{' '}
              <a
                href={STANDARDS_PATH}
                className="underline"
                target="_blank"
                rel="noopener noreferrer"
              >
                support responsible breeders
              </a>{' '}
              who are dedicated to bringing healthy and happy dogs to their
              forever homes.
            </p>
          </PayPrefenceQuestionDrawer>
        </Drawer>
      </FullPageQuizQuestion>
    </div>
  );
}

QuizGoodDogPayPreferenceQuestion.propTypes = {
  handleNextClick: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};
